import { FileCheck, Pencil, Palette, Layout, HelpCircle } from "lucide-react";
import { DESIGN_OPTIONS, WizardFormData } from "@/types/wizard";

interface Step5DesignStatusProps {
  formData: WizardFormData;
  updateFormData: (updates: Partial<WizardFormData>) => void;
  isDark: boolean;
}

const iconMap: Record<string, React.ReactNode> = {
  have_permit: <FileCheck className="w-8 h-8" />,
  working_with_architect: <Pencil className="w-8 h-8" />,
  want_custom: <Palette className="w-8 h-8" />,
  pre_designed: <Layout className="w-8 h-8" />,
  not_sure: <HelpCircle className="w-8 h-8" />,
};

const Step5DesignStatus = ({ formData, updateFormData, isDark }: Step5DesignStatusProps) => {
  const getCardStyles = (isSelected: boolean) => {
    if (isSelected) {
      return {
        backgroundColor: "#E4683B",
        color: "#ffffff",
        boxShadow: isDark
          ? "4px 4px 8px #000000, -4px -4px 8px #141414"
          : "4px 4px 8px #d1d1d1, -4px -4px 8px #ffffff",
      };
    }
    return {
      backgroundColor: isDark ? "#0a0a0a" : "#ffffff",
      color: isDark ? "#ffffff" : "#1a1a1a",
      boxShadow: isDark
        ? "4px 4px 8px #000000, -4px -4px 8px #141414"
        : "4px 4px 8px #d1d1d1, -4px -4px 8px #ffffff",
    };
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 
          className="text-2xl md:text-3xl font-bold mb-2"
          style={{ color: "#E4683B" }}
        >
          Where are you in the design process?
        </h2>
        <p 
          className="text-lg opacity-80"
          style={{ color: isDark ? "#ffffff" : "#1a1a1a" }}
        >
          This helps us understand how to best assist you
        </p>
      </div>

      <div className="max-w-2xl mx-auto space-y-4">
        {DESIGN_OPTIONS.map((option) => {
          const isSelected = formData.designChoice === option.value;
          
          return (
            <button
              key={option.value}
              onClick={() => updateFormData({ designChoice: option.value })}
              className="w-full p-5 rounded-2xl text-left transition-all duration-300 hover:scale-[1.01]"
              style={getCardStyles(isSelected)}
            >
              <div className="flex items-center gap-4">
                <div 
                  className="flex-shrink-0"
                  style={{ color: isSelected ? "#ffffff" : "#E4683B" }}
                >
                  {iconMap[option.value]}
                </div>
                <span className="font-medium text-lg">{option.label}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Step5DesignStatus;
